import { castToSnapshot, getParent, types } from 'mobx-state-tree';
import { createThunk, model } from 'mst-collection';

import { Api, schemas, FriendshipTypeEnum } from '@api';
import {
  handleFlow,
  shouldRejectPagination,
  ExtendedListModel,
} from '../utils';
import { UserModel, User } from './UserModel';

export class FriendshipUserList extends ExtendedListModel(
  types.reference(types.late(() => UserModel)),
  {
    totalCount: 0,
    friendshipType: types.enumeration(
      Object.values(FriendshipTypeEnum),
    ),
  },
  {
    idAttribute: 'id',
    schema: schemas.UserListSchema,
    pageSize: 30,
  },
) {
  private get _parentUserId() {
    return getParent<User>(this).id;
  }

  setTotalCount(value: number) {
    this.totalCount = value;
  }

  fetch = createThunk(() => {
    return async function fetch(this: FriendshipUserList) {
      const res = await Api.Friendships.getFriendshipUsers({
        id: this._parentUserId,
        friendshipType: this.friendshipType,
        count: this.pageSize,
      });

      this.set(res.data.users);
      this.setTotalCount(res.data.totalCount);
    };
  });

  fetchMore = createThunk(() => {
    return async function fetchMore(this: FriendshipUserList, flow) {
      if (shouldRejectPagination(this)) {
        return;
      }

      await handleFlow(flow, async () => {
        const res = await Api.Friendships.getFriendshipUsers({
          id: this._parentUserId,
          friendshipType: this.friendshipType,
          count: this.pageSize,
          start: this.offset,
        });

        this.append(castToSnapshot(res.data.users));
      });
    };
  }, false);
}

export const FriendshipUserListModel = model(FriendshipUserList);
